import { startConsentSync } from '@/components/app/consent_management/consent-sync';

startConsentSync();
